import React, { useState } from "react";

import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  IconButton,
  Slide,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

import { Form, Formik } from "formik";
import { LazyLoadImage } from "react-lazy-load-image-component";

import GcashLogo from "../../../../../assets/GCASH-logo-new.png";
import CollapseAlert from "../../../../../core/CollapseAlert";

import CloseIcon from "@mui/icons-material/Close";
import { handleVortexRequest } from "../../../functions/VortexGcashFunctions";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function useConfirmGcash() {
  const [show, setshow] = useState(false);

  const [transactionData, setTransactionData] = useState({});

  const showConfirmGcash = ({ data }) => {
    setshow(true);
    setTransactionData(data);
  };

  const closeConfirmGcash = () => {
    setshow(false);
  };

  const ConfirmGcashDialog = ({ onCloseDialog = () => {} }) => {
    const [isSuccess, setIsSuccess] = useState(false);

    const [alertState, setAlertState] = useState({
      open: false,
      severity: "success",
      message: "Message",
    });

    const submitHandler = async (data) => {
      try {
        console.log(data);

        await handleVortexRequest(transactionData, data?.gCashTransactionRefNo);

        setIsSuccess(true);
      } catch (error) {
        setAlertState({
          open: true,
          severity: "error",
          message: String(error),
        });
      }
    };

    return (
      <Dialog open={show} TransitionComponent={Transition} fullWidth>
        <DialogContent>
          <Formik
            initialValues={{}}
            onSubmit={async (data) => {
              await submitHandler(data);
            }}
          >
            {({ isSubmitting, handleChange }) => {
              return (
                <Form>
                  <Stack spacing={2}>
                    <Stack
                      direction={"row"}
                      justifyContent={"space-between"}
                      alignContent={"center"}
                    >
                      <Box>
                        <LazyLoadImage
                          src={GcashLogo}
                          alt="gcash-logo"
                          width={"100px"}
                        />
                      </Box>
                      <IconButton
                        onClick={() => {
                          closeConfirmGcash();
                          onCloseDialog();
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Stack>
                    {isSuccess ? (
                      <Alert severity="success">
                        Process completed — check current status!
                      </Alert>
                    ) : (
                      <Stack spacing={2}>
                        <TextField
                          name={"gCashTransactionRefNo"}
                          variant="outlined"
                          label="GCASH transaction ref. no."
                          onChange={handleChange}
                        />
                        <CollapseAlert
                          open={alertState.open}
                          severity={alertState.severity}
                          message={alertState.message}
                        />
                        <Button
                          variant={"contained"}
                          type={"submit"}
                          disabled={isSubmitting}
                          onClick={() => {}}
                        >
                          {isSubmitting ? (
                            <CircularProgress />
                          ) : (
                            <Typography>Confirm</Typography>
                          )}
                        </Button>
                      </Stack>
                    )}
                  </Stack>
                </Form>
              );
            }}
          </Formik>
        </DialogContent>
      </Dialog>
    );
  };

  return { showConfirmGcash, closeConfirmGcash, ConfirmGcashDialog };
}
